module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-96x96-88fd7c05d8c867dc29557932f257a062.png";